<template>
  <div
    @click="selectComponent(model)"
    :class="['dr-page', { 'dr-page-editor-mode': isInEditorMode, 'dr-page-selected' : isSelected }, evaluateClasses({ classes: this.model.Class })]"
    :style="setWidthOnCanvas()"
  >
    <component
      :readonly="readonly"
      v-if="layoutModel"
      :is="layoutModel.$Type"
      :model="layoutModel"
      @modelChanged="$emit('modelChanged', model)"
      @close-dialog="$emit('close-dialog')"
    />
  </div>
</template>

<script>
import baseMixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import layouts from '../../layouts/layouts'

export default {
  mixins: [baseMixin, inputMixin],
  data: () => ({
    allLayouts: layouts
  }),
  computed: {
    layoutModel() {
      return loadLayout(this.model.Layout)?.Model
    }
  },
  methods: {
    setWidthOnCanvas() {
      if (!this.model.Width) {
        return ''
      }

      // если тип странцы всплывающая, ширина будет применена только к компоненту v-dialog
      return this.model.LayoutType === 'responsive' ? `width: ${this.model.Width}px` : ''
    }
  }
}

function loadLayout(layout) {
  let fLayout = layouts.find( l => l.$ID === layout)
  if (!fLayout) {
    // for non-existent layouts we use a stub to render the page correctly
    return layouts.find( layout => layout.$ID === 'DefaultLayout')
  }
  return fLayout
}
</script>

<style>
.dr-page-selected{
  outline:2px solid #FFA500;
  outline-offset: -2px;
}
.dr-page-editor-mode{
  position: relative;
  overflow: hidden;
}
.dr-page-editor-mode:hover::after {
    content: "";
    position: absolute;
    display: block;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.29);
}
</style>
